import { render, staticRenderFns } from "./ArchiveExhibitions.vue?vue&type=template&id=8ebf34e0&"
import script from "./ArchiveExhibitions.vue?vue&type=script&lang=js&"
export * from "./ArchiveExhibitions.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveExhibitions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports